import type { ContextViewStep } from "../../context/useContextViewState";
import { SetupForm } from "./SetupForm";
import { PagePickerStep } from "./PagePickerStep";
import { AnalysingLoader } from "./AnalysingLoader";
import { QuestionsStep } from "./QuestionsStep";
import { ContextView, type ContextViewOptions } from "./ContextView";

interface SetupFormOptions {
  variant?: "create" | "add-context";
  onCancel?: () => void;
  onSuggestionsStarted?: () => void;
}

interface BoardContextWizardStepsProps {
  step: ContextViewStep;
  includeContextView?: boolean;
  setupOptions?: SetupFormOptions;
  contextViewOptions?: ContextViewOptions;
}

export const BoardContextWizardSteps = ({
  step,
  includeContextView = true,
  setupOptions,
  contextViewOptions,
}: BoardContextWizardStepsProps) => {
  switch (step) {
    case "setup":
      return (
        <SetupForm
          variant={setupOptions?.variant}
          onCancel={setupOptions?.onCancel}
          onSuggestionsStarted={setupOptions?.onSuggestionsStarted}
        />
      );
    case "page-picker":
      return <PagePickerStep />;
    case "analysing":
      return <AnalysingLoader variant="questions" />;
    case "questions":
      return <QuestionsStep />;
    case "building":
      return <AnalysingLoader variant="context" />;
    case "suggesting":
      return includeContextView ? <ContextView {...contextViewOptions} /> : null;
    case "context-view":
      return includeContextView ? <ContextView {...contextViewOptions} /> : null;
    default:
      return null;
  }
};
